import state from './Platform/states'
import mutations from './Platform/mutations'
import actions from './Platform/actions'
import getters from './Platform/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
